<template>
  <div id="app">
    <div class="container">
      <div class="page-header" v-if="showHeader">
        <div class="row align-items-center justify-content-between">
          <div class="col">
            <img src="@/assets/aio-logo.png"
                 srcset="@/assets/aio-logo.png 1x, @/assets/aio-logo@2x.png 2x, @/assets/aio-logo@3x.png 3x"
                 class="img-fluid" alt="aio* logo">
          </div>
          <div class="col">
            <h1 class="text-right">
              <small>{{title}}</small>
            </h1>
          </div>
        </div>
      </div>
      <router-view @set-title="setTitle" @show-header="setHeaderVisibility"/>
      <Notifications/>
    </div>
  </div>
</template>

<script>
  import Notifications from '@/components/Notifications'

  export default {
    name: 'app',
    components: {
      Notifications
    },
    data () {
      return {
        showHeader: true,
        title: ''
      }
    },
    methods: {
      setHeaderVisibility (isVisible) {
        this.showHeader = isVisible
      },
      setTitle (title) {
        this.title = title
      }
    }
  }
</script>
